import { Spinner } from "./Spinner.style";

export default Spinner;
